export default "__VITE_ASSET__MF03nOAw__"